<div class="bg-warning text-black w-full overflow-hidden z-50 relative"
  [ngClass]="{'h-0 p-0px px-0px opacity-0': !showBanner || !active, 'py-12px opacity-1': showBanner && active, 'duration-200': banner?.allowDismiss ?? false}"
  role="alert" #bannerElement>
  <div class="px-16px flex items-center gap-12px">
    <svg class="text-black shrink-0 self-baseline" width="20" height="20" aria-hidden="true">
      <use xlink:href="#icon-info-sqr-rounded" />
    </svg>
    @if (banner && banner.title) {
      <div class="text-14 leading-5">
        <b>{{banner.title}}</b>
      </div>
    }
    @if (banner?.content) {
      <div class="text-14 leading-5" [innerHTML]="banner.content"> </div>
    }
    @if (banner?.action?.url) {
      <a [href]="banner.action.url" [target]="banner.action.target"
        class="banner-action btn-primary-black-xs">{{banner.action.label}} <span
      aria-hidden="true"></span></a>
    }
    @if (banner?.allowDismiss) {
      <button class="ml-auto text-black hover:text-black/50 active:block/30 btn-icon p-2px self-start" type="button"
        aria-label="Dismiss" (click)="dismiss()">
        <span class="sr-only">Dismiss</span>
        <svg width="16" height="16">
          <use xlink:href="#icon-banner-close" />
        </svg>
      </button>
    }
  </div>
</div>
